import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { testimonials as mockTestimonials, faqs as mockFaqs, stats as mockStats } from '../mock';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DEFAULT_CONTENT = {
  hero: {
    badge: 'No hardware. No monthly fee.',
    title: 'Take payments',
    titleAccent: 'anywhere',
    titleEnd: 'your phone goes.',
    subtitle: 'FLIX turns your phone into a card machine. Tap to accept any card or wallet in person, or send a link to get paid online \u2014 money lands in seconds.',
  },
  stats: mockStats,
  pricing: [
    { name: 'Tap to Pay', price: '1.4%', unit: 'per in-person tap', highlight: true,
      features: ['No monthly fee', 'No setup cost', 'Paid in seconds', 'All cards & wallets', 'Free FLIX card'] },
    { name: 'Payment Links', price: '3.9%', unit: '+ $0.30 per link', highlight: false,
      features: ['Sell from anywhere', 'No app for customers', 'Send by text or email', 'Same price always', 'Instant payouts'] },
    { name: 'Bank Transfer', price: '1.4%', unit: '+ $0.99 per transfer', highlight: false,
      features: ['Same-day settlement', 'Move to any bank', 'Full control', 'No hidden charges', 'Track every move'] },
  ],
  testimonials: mockTestimonials,
  faqs: mockFaqs,
};

const ContentContext = createContext(DEFAULT_CONTENT);

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULT_CONTENT);

  const refresh = async () => {
    try {
      const res = await axios.get(`${API}/content`);
      setContent({ ...DEFAULT_CONTENT, ...res.data });
    } catch (e) {
      setContent(DEFAULT_CONTENT);
    }
  };

  useEffect(() => { refresh(); }, []);

  return (
    <ContentContext.Provider value={{ content, refresh }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
